import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { refreshHousehold } from './data/household';
import { ensurePlacements } from './data/routeAssist';
import { closeStaleVisits } from './data/shopping';
import { initClock } from './db/clock';
import { currentHouseholdId, currentUserId, refreshSession } from './lib/auth';
import { syncPushSubscription } from './lib/push';
import { syncEngine } from './sync/engine';
import { startLive } from './sync/live';
import './styles.css';

/** Domownicy odświeżani po synchronizacji najwyżej raz na minutę. */
const HOUSEHOLD_REFRESH_MS = 60_000;

async function boot() {
  await initClock();
  // Prośba, by przeglądarka nie usuwała danych offline (lista i niewysłane zmiany).
  void navigator.storage?.persist?.();
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
  syncEngine.onHouseholdChanged = (householdId) => {
    // Dom zmieniony gdzie indziej (dołączenie na innym urządzeniu, scalenie) — sesja i domownicy od nowa.
    if (currentHouseholdId() !== householdId) void refreshSession();
    void refreshHousehold();
  };
  await refreshSession();
  syncEngine.afterSync = async () => {
    await closeStaleVisits();
    void refreshHousehold({ ifOlderThanMs: HOUSEHOLD_REFRESH_MS });
    // Miejsca na trasie dla nowych produktów z aktywnych list (AI, w tle).
    void ensurePlacements();
  };
  syncEngine.start();
  startLive();
  if (currentUserId()) {
    void refreshHousehold({ ifOlderThanMs: HOUSEHOLD_REFRESH_MS });
    void syncPushSubscription();
  }
  // Kliknięte powiadomienie, gdy service worker nie mógł sam przejść pod adres (okno spoza jego kontroli).
  navigator.serviceWorker?.addEventListener('message', (e: MessageEvent<{ type?: string; url?: string }>) => {
    if (e.data?.type !== 'navigate' || !e.data.url) return;
    const url = new URL(e.data.url, location.origin);
    if (url.origin === location.origin && url.href !== location.href) location.assign(url.href);
  });
}

void boot();
